import { configureStore } from "@reduxjs/toolkit";
import chatReducer from "../app/chat/chatSlice";
import chatAgentReducer from "./chatAgent/chatAgentSlice";
import dashboardReducer from "../app/dashboard/dashboardSlice";

import agentMonitorReducer from "../app/agentMonitor/agentMonitorSlice";
import authReducer from "../app/auth/authSlice";
import callReducer from "../app/call/callSlice";
import videoCallReducer from "../app/videocall/videoSlice";
import userStateReducer from "./userState/userStateSlice";
import layoutStateReducer from "./layout/layoutStateSlice";
import callMiddleware from "./call/middleware";
import vCallMiddleware from "./videocall/middleware";
import chatMiddleware from "./chat/middleware";
import chatAgentMiddleware from "./chatAgent/middleware";
import dashboardMiddleware from "./dashboard/middleware";
import agentMonitorMiddleware from "./agentMonitor/middleware";
import broadcastReducer from "./wa-broadcast/waBroadcastSlice";
import serviceGroupReducer from "./serviceGroup/serviceGroupSlice";

export const store = configureStore({
    reducer: {
        auth: authReducer
        , call: callReducer
        , chat: chatReducer
        , chatagent: chatAgentReducer
        , vcall: videoCallReducer
        , userstate: userStateReducer
        , layoutstate: layoutStateReducer
        , dashboard: dashboardReducer
        , agentmonitor: agentMonitorReducer
        , broadcast: broadcastReducer
        , serviceGroup: serviceGroupReducer
    },
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware({ serializableCheck: false }).concat([vCallMiddleware, callMiddleware, chatMiddleware,
            chatAgentMiddleware, dashboardMiddleware, agentMonitorMiddleware])
    },
    devTools: process.env.NODE_ENV === 'development'
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
